import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <Link to="/" className="inline-block cursor-pointer">
                <h2 className="font-heading text-4xl font-bold text-background-50">
                  虚空
                </h2>
              </Link>
              <p className="mt-4 text-sm text-foreground-200 leading-relaxed max-w-md">
                虚空韩漫网集免费韩漫、漫画大全、在线漫画和好看的韩国漫画于一体，致力于打造最全面的韩漫数字图书馆。每日更新，高清画质，畅享阅读。
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-3">
              <h3 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-6">联系我们</h3>
              <div className="space-y-5">
                <div>
                  <p className="text-sm text-foreground-200 leading-relaxed">
                    上海市浦东新区张江高科技园区
                  </p>
                  <p className="text-sm text-foreground-200 leading-relaxed">
                    碧波路888号
                  </p>
                </div>
                <div>
                  <p className="text-sm text-foreground-200">021-5888-6666</p>
                </div>
                <div>
                  <p className="text-sm text-foreground-200">hello@txtjly.com</p>
                </div>
              </div>
            </div>

            <div className="md:col-span-4">
              <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%2C%20beautiful%20anime%20characters%20reading%20books%20in%20cozy%20library%2C%20warm%20ambient%20lighting%2C%20Korean%20digital%20art%2C%20soft%20dreamy%20atmosphere%2C%20pastel%20color%20palette%2C%20clean%20composition&width=800&height=600&seq=footer-manga-art&orientation=landscape"
                  alt="虚空韩漫网 - 韩漫数字图书馆"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 虚空韩漫网. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                关于我们
              </Link>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}